import { Component } from 'react'

import * as h from 'h'

import styles from './styles.scss'

const iconItem = ({ href, iconClass }) =>
  h.li(h.ca(styles.navItem),
    h.a({ href, ...h.ca(styles.btn) },
      h.icon({ name: iconClass })))

export default class UConnBanner extends Component {
  shouldComponentUpdate () {
    return false
  }

  render () {
    return h.nav(h.ca(styles.uconnBanner),
      h.a({ href: 'http://uconn.edu', ...h.ca(styles.brand), name: 'UConn Home Page' },
        h.img({ src: '/img/uconn-wordmark-single-white.png', alt: 'UConn', name: 'UConn Banner' })),
      h.ul(h.ca(styles.redButtonMenu),
        h.h(iconItem, { href: 'http://uconn.edu/search', iconClass: 'search' }),
        h.h(iconItem, { href: 'http://uconn.edu/az/', iconClass: 'sort-alpha-asc' })))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/UConnBanner/index.js